import { Model as d } from "../../../model.js";
class r extends d {
  constructor(s) {
    super(), this.pickUpAddress = s.pickUpAddress, this.pickUpName = s.pickUpName, this.pickUpPhoneNumber = s.pickUpPhoneNumber, this.pickUpAt = s.pickUpAt, this.dropOffAddress = s.dropOffAddress, this.dropOffAddressLatitude = s.dropOffAddressLatitude, this.dropOffAddressLongitude = s.dropOffAddressLongitude, this.dropOffAt = s.dropOffAt, this.dropOffNotes = s.dropOffNotes, this.assignedDeliveryOperators = s.assignedDeliveryOperators;
  }
}
export {
  r as TicketDeliveryModel
};
//# sourceMappingURL=ticketDelivery.model.js.map
